/** Navigates the user to the Dashboard if logged in, or the login screen if not. */
// const useNavigateFromLogo = () => {
//   const params = useParams()
import GoTackleLogo from 'assets/images/GoTackle-Logo.svg'

import { AppFC } from 'types'
import React, { useCallback } from 'react'
import history from 'utils/history'
import { useTenantId } from 'utils/useTenantId'
import { getCurrentRoute, getRoleFromPath, getTabName } from 'utils/helper'
import { useSelector } from 'react-redux'
import { RootState } from 'App'
import { PathNames } from 'config'
import { getInitials } from 'components/Chat/helper'
import { ampli } from 'ampli'
import { isEmpty } from 'lodash'
import { useSenatorBrandedLogo } from 'hooks/useSenatorBrandedLogo'

//   const navigate = useCallback(() => {
//     const path = params.tenantId ? `/${params.tenantId}/dashboard` : '/auth/login'
//     history.push(path)
//   }, [params.tenantId])

//   return navigate
// }

interface ILogoNavigationButton {
  logo?: string
  className?: string
  isNavbarItem?: boolean
}

const LogoNavigationButton: AppFC<ILogoNavigationButton> = ({
  logo = GoTackleLogo,
  className = '',
  isNavbarItem = false,
}) => {
  // const navigate = useNavigateFromLogo()
  const organizationDetail = useSelector((state: RootState) => state.bso.bsoProfile)
  const tenantId = useTenantId()
  const path = getCurrentRoute()
  const senatorBrandedLogo = useSenatorBrandedLogo()

  const redirectTo = useCallback(
    (triggeredFrom: string) => {
      if (!getCurrentRoute().includes(PathNames.Dashboard)) {
        ampli.dashboardViewed({ previousPath: getTabName(), triggeredFrom })
        history.push(`/${getRoleFromPath()}/${tenantId}/${PathNames.Dashboard}`)
      }
    },
    // eslint-disable-next-line
    [path, tenantId]
  )
  const initial = getInitials({ firstName: organizationDetail?.name, lastName: '' })

  return (
    <div onClick={() => null} className={`${className} w-fit`}>
      <div className="w-full">
        {!isNavbarItem && (
          <img src={logo} alt="GoTackle icon" className="relative top-0.5 h-full min-h-6" />
        )}
        {isNavbarItem && (
          <div className="flex items-center gap-4 hover:cursor-pointer">
            {senatorBrandedLogo?.url || organizationDetail?.logoUrl ? (
              <img
                src={senatorBrandedLogo?.url || organizationDetail?.logoUrl}
                alt={senatorBrandedLogo?.alt || 'organization logo'}
                className="h-8 w-8 sm:h-10 sm:w-10 object-cover rounded-full"
                onClick={() => redirectTo('organization logo')}
              />
            ) : (
              <span
                className={`rounded-full bg-black w-8 h-8 flex-shrink-0 inline-flex justify-center items-center cursor-pointer`}
                onClick={() => redirectTo('organization logo')}
              >
                <span className="text-white font-bold uppercase text-xl">
                  {!isEmpty(initial) ? initial : 'G'}
                </span>
              </span>
            )}
            <p
              className="font-secondary font-base font-black text-black-light xs:hidden sm:flex"
              onClick={() => redirectTo('organization name')}
            >
              {organizationDetail.name}
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default LogoNavigationButton
